import React from 'react';

/**
 * A minimal overlay dialog — sgokit had no modal primitive before the
 * Partners page header needed one for "Add partner" and "Bulk import".
 * Styled with the existing `.sgk-modal` vocabulary (sgokit.css); no focus
 * trap or portal — the admin console has nothing else stacked above it.
 */
const Modal: React.FC<{
  title: string;
  hint?: React.ReactNode;
  onClose: () => void;
  wide?: boolean;
  footer?: React.ReactNode;
  children: React.ReactNode;
  testId: string;
}> = ({ title, hint, onClose, wide, footer, children, testId }) => (
  <div
    className="sgk-modal-overlay"
    data-testid={`${testId}-overlay`}
    onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
  >
    <div className={`sgk-modal${wide ? ' sgk-modal--wide' : ''}`} data-testid={testId}>
      <div className="sgk-modal__header">
        <div>
          <h2 className="sgk-modal__title">{title}</h2>
          {hint && <p className="sgk-modal__hint">{hint}</p>}
        </div>
        <button
          type="button"
          className="sgk-modal__close"
          onClick={onClose}
          aria-label="Close"
          data-testid={`${testId}-close-button`}
        >
          ×
        </button>
      </div>
      <div className="sgk-modal__body">{children}</div>
      {footer && <div className="sgk-modal__footer">{footer}</div>}
    </div>
  </div>
);

export default Modal;
